(() => {
  const SELECTOR = '[data-scroll-top]';
  const VISIBLE = 'is-visible';
  const THRESHOLD = 10;

  function init() {
    const button = document.querySelector(SELECTOR);
    if (!button) return;

    let ticking = false;

    const scrollable = () => {
      const doc = document.documentElement;
      return Math.max(0, doc.scrollHeight - window.innerHeight);
    };

    const update = () => {
      const top = window.scrollY || document.documentElement.scrollTop || 0;
      const max = scrollable();
      const progress = max > 0 ? Math.min(100, Math.max(0, (top / max) * 100)) : 0;

      button.style.setProperty('--scroll-top-progress', progress.toFixed(2));
      button.classList.toggle(VISIBLE, top > THRESHOLD);
    };

    const request = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(request).observe(document.body);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
